module.exports = "/fonts/Cabin-Medium.ttf";